import ValidationInterface from '@/plans/common/validation-interface';
import {
  SDKUCCategories,
  SDKCategories,
  basePlanCategories,
  basicPlusCategories,
} from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    return [];
  }

  async conflicts() {
    return this.current(SDKUCCategories).conflict([
      ...SDKUCCategories,
      ...basePlanCategories,
      ...basicPlusCategories,
      ...SDKCategories]);
  }
}
